export enum PurposeEnum {
  DOG_HEALTHY = 1,
  DOG_CARDIOPATHY = 2,
  DOG_CASTRATED = 3,
  DOG_CANCER = 4,
  DOG_CONSTIPATION_FIBER_RESPONSIVE = 5,
  DOG_WEANING = 6,
  DOG_DIABETES = 7,
  DOG_HEPATOBILIARY_DISEASES = 8,
  DOG_CKD_WITH_PROTEINURIA = 9,
  DOG_CKD_WITHOUT_PROTEINURIA = 10,
  DOG_OSTEOARTICULAR_DISEASES = 11,
  DOG_GASTROENTEROPATHIES = 12,
  DOG_PREGNANT = 13,
  DOG_HYPERLIPIDEMIA = 14,
  DOG_FOOD_HYPERSENSITIVITY = 15,
  DOG_LACTATING = 16,
  DOG_OBESITY = 17,
  DOG_DERMATOLOGICAL_SENSITIVITY = 18,
  DOG_TENDENCY_OBESITY = 19,
  DOG_UROLITHIASIS = 20,
  DOG_ASSISTED_NUTRITION = 44,

  CAT_HEALTHY = 21,
  CAT_CARDIOPATHY = 22,
  CAT_CASTRATED = 23,
  CAT_CANCER = 24,
  CAT_CONSTIPATION_FIBER_RESPONSIVE = 25,
  CAT_WEANING = 26,
  CAT_DIABETES = 27,
  CAT_HEPATOBILIARY_DISEASES = 28,
  CAT_CKD_WITH_PROTEINURIA = 29,
  CAT_CKD_WITHOUT_PROTEINURIA = 30,
  CAT_EARLY_RENAL_DISEASE = 31,
  CAT_OSTEOARTICULAR_DISEASES = 32,
  CAT_GASTROENTEROPATHIES = 33,
  CAT_PREGNANT = 34,
  CAT_HYPERLIPIDEMIA = 35,
  CAT_FOOD_HYPERSENSITIVITY = 36,
  CAT_LACTATING = 37,
  CAT_OBESITY = 38,
  CAT_LONG_HAIR = 39,
  CAT_DERMATOLOGICAL_SENSITIVITY = 40,
  CAT_TENDENCY_OBESITY = 41,
  CAT_UROLITHIASIS_STRUVITE = 42,
  CAT_UROLITHIASIS_CALCIUM_OXALATE = 43,
  CAT_ASSISTED_NUTRITION = 45
}
